/* eslint-disable react-native/no-inline-styles */
import {useNavigation, useRoute} from '@react-navigation/native';
import {Button, Text} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {StyleSheet, View} from 'react-native';
// import {useSelector} from 'react-redux';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {getIosPrice, px, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import {Page, TimeTable, TitleRow} from '../components';
import {PaymentErrorModal} from './../Payment/PaymentErrorModal';

const PackagePurchaseSummary = ({
  landscapeParams,
  setLandscapeRouteAndParams,
}) => {
  // this state is added to fix modal rendering
  const [renderTimeTable, setRenderTimeTable] = useState(false);
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const {params} = useRoute();
  // const subjects = useSelector((state) => state.general.subjects);
  const {
    iosProductId,
    packageId,
    packageType,
    totalPrice,
    unitPrice,
    selectedStudent,
    selectedTimeTable,
    monthNumber,
    packageTitle,
  } = landscapeParams || params;

  let isPaymentError = false;
  if (
    selectedTimeTable &&
    selectedTimeTable.length > 0 &&
    selectedTimeTable[0].scheduleId
  ) {
    console.log('Process to payment');
  } else {
    isPaymentError = true;
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setRenderTimeTable(true);
    }, 10);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Page
      header={{
        title: 'Summary',
        showBackAction: true,
        onModalBackPressed() {
          setLandscapeRouteAndParams(
            AUTHENTICATED_ROUTES.selectTimeTable.path,
            undefined,
          );
        },
      }}
      useModalView={isLandscape}>
      {renderIf(isPaymentError, <PaymentErrorModal />)}
      <View
        style={{
          flexDirection: 'row',
          padding: 17,
        }}>
        <Text style={{flex: 2, fontSize: 16, fontWeight: '600'}}>
          {packageTitle}
        </Text>
        <Text
          style={{
            flex: 1,
            fontSize: 16,
            fontWeight: '600',
            alignSelf: 'flex-end',
            textAlign: 'right',
          }}>
          RM {getIosPrice(totalPrice)}
        </Text>
      </View>
      {/* <BulletList
        title="Selected subjects:"
        list={selectedTimeTable.map(({subjectId}) =>
          getSubjectNameById({
            id: subjectId,
            subjects,
          }),
        )}
        style={[styles.marginTop, styles.padding]}
      /> */}
      <TitleRow
        title="Selected timetable:"
        type="secondary"
        containerStyle={styles.marginTop}
      />

      {renderTimeTable && (
        <TimeTable hideTitle data={!isPaymentError ? selectedTimeTable : []} />
      )}

      <Button
        style={styles.submitButton}
        onPress={() => {
          const paramsToSet = {
            packageId,
            iosProductId,
            packageTitle,
            kidId: selectedStudent?.id,
            selectedTimeTable,
            subjectNames: undefined,
            renewData: undefined,
            packageType,
            totalPrice,
            unitPrice,
            monthNumber,
          };
          const routeToSet = AUTHENTICATED_ROUTES.payment.path;

          if (isLandscape) {
            setLandscapeRouteAndParams(routeToSet, paramsToSet);
          } else {
            navigation.navigate(routeToSet, paramsToSet);
          }
        }}>
        {totalPrice === 0 ? 'Continue' : 'Proceed To Payment'}
      </Button>
    </Page>
  );
};

const styles = StyleSheet.create({
  padding: {
    paddingHorizontal: px(17),
  },
  marginTop: {
    marginTop: px(30),
  },
  submitButton: {
    margin: px(17),
    marginTop: px(30),
  },
});

export default PackagePurchaseSummary;
